export const MUTATE_SHOW_FOOTER = 'MUTATE_SHOW_FOOTER';
export const MUTATE_SHOW_NAVIGATION = 'MUTATE_SHOW_NAVIGATION';
export const MUTATE_LOADER = 'MUTATE_LOADER';

interface IUIStore {
    showFooter: boolean;
    showNavigation: boolean;
    loading: boolean;
}

// initial state
const UIState: IUIStore = {
    showFooter: true,
    showNavigation: true,
    loading: false
};

// getters
const getters = {
    getShowFooter: ( state: IUIStore ) => state.showFooter,
    getShowNavigation: ( state: IUIStore ) => state.showNavigation,
    getLoader: ( state: IUIStore ) => state.loading,
};

// mutations
const mutations = {
    [MUTATE_SHOW_FOOTER](state: IUIStore, payload: boolean) {
        state.showFooter = payload;
    },
    [MUTATE_SHOW_NAVIGATION](state: IUIStore, payload: boolean) {
        state.showNavigation = payload;
    },
    [MUTATE_LOADER](state: IUIStore, payload: boolean) {
        state.loading = payload;
    },
};

// actions
const actions = {
};

export default {
    state: UIState,
    getters,
    actions,
    mutations,
};
